module.exports = new __parcel__URL__("repository.7bf0dc01.png").toString();